import React from 'react';

const SVG = ({ style = {}, mode, color = 'rgb(125,167,236)', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="tt-clip-CORNERS">
        <rect x="50" width="50" height="50" />
        <rect y="50" width="50" height="50" />
      </clipPath>
      <clipPath id="tt-clip-SIDES">
        <rect x="50" width="50" height="100" />
      </clipPath>
    </defs>
    <circle cx="50" cy="50" r="47" strokeWidth="6" stroke={color} fill="none" />
    <circle cx="50" cy="50" r="47" fill={color} clipPath={`url(#tt-clip-${mode})`} />
  </svg>
);

export default SVG;
